import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import "../../assets/css/bundle.scss";
import image from "../../assets/images/bundle.png";
import { BundleOffer, BundlePanels } from "../../types/global.types";
import {
  getTrackingBundleById,
  postTrackingBundleById,
} from "../../services/offers/offers.service";
import { EMAIL_REGEX } from "../../utility/regexp";

function BundleLayout() {
  const { id } = useParams();
  const [panel, setPanel] = useState<BundlePanels>(BundlePanels.faqs);
  const [bundleOffer, setBundleOffer] = useState<BundleOffer | null>(null);
  const [acceptEmail, setAcceptEmail] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const getBundleOffer = async (id: string) => {
      setIsLoading(true);
      const response = await getTrackingBundleById(id);

      if (response?.data?.status) {
        setBundleOffer(response?.data?.result);
      }
      setIsLoading(false);
    };

    if (id) {
      getBundleOffer(id);
    }
  }, [id]);

  const isValid: boolean = useMemo(() => {
    return acceptEmail && email.match(EMAIL_REGEX) !== null;
  }, [acceptEmail, email]);

  const handleSubmit = async () => {
    setIsLoading(true);
    if (bundleOffer && !isLoading) {
      const response = await postTrackingBundleById(
        bundleOffer.id,
        bundleOffer.userSession,
        email
      );

      if (response?.data?.status) {
        window.location.href = bundleOffer.trackingURL;
      } else {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="bundle-layout">
      {bundleOffer ? (
        <>
          <div className="bundle-content">
            <div className="bundle-image">
              <img src={bundleOffer?.imageUrl || image} alt="" />
            </div>
            <div className="bundle-description">
              <h1>{bundleOffer.title}</h1>
              <p
                dangerouslySetInnerHTML={{
                  __html: bundleOffer.longDescription,
                }}
              ></p>
              <div className="bundle-input">
                <label htmlFor="email">
                  <div className="bundle-input-label">
                    Please input your email to receive your offer
                  </div>
                  <input
                    type="email"
                    id="email"
                    placeholder="e.g.my@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    tabIndex={0}
                  />
                  <div className="bundle-input-agreement">
                    <label
                      htmlFor="accept-email"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setAcceptEmail(!acceptEmail);
                        }
                      }}
                    >
                      <input
                        id="accept-email"
                        type="checkbox"
                        checked={acceptEmail}
                        onChange={() => setAcceptEmail(!acceptEmail)}
                      />
                      <div className="checkboxsvg"></div>
                      <span> I have read and agree to the</span>{" "}
                      <a
                        href="https://brandswap.com/privacy/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                    </label>
                  </div>
                </label>
              </div>
              <button
                className="bundle-button"
                onClick={handleSubmit}
                disabled={!isValid}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
              >
                {bundleOffer.offerCTAText}
                {isLoading && (
                  <div className="icon-spin">
                    <svg
                      className="spin"
                      viewBox="0 0 1024 1024"
                      focusable="false"
                      data-icon="loading"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                    </svg>
                  </div>
                )}
              </button>
            </div>
          </div>

          {bundleOffer.faqs && (
            <div className="bundle-panel">
              <div
                className="bundle-panel-header"
                onClick={() => setPanel(BundlePanels.faqs)}
              >
                <svg
                  className={panel === BundlePanels.faqs ? "rotate" : ""}
                  width="11"
                  height="6"
                  viewBox="0 0 11 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.78033 5.78033C1.48744 6.07323 1.01256 6.07323 0.71967 5.78033C0.426777 5.48744 0.426777 5.01256 0.71967 4.71967L5.21967 0.219671C5.5036 -0.0642633 5.96079 -0.0741975 6.25679 0.197135L10.7568 4.32214C11.0621 4.60203 11.0828 5.07646 10.8029 5.3818C10.523 5.68713 10.0485 5.70776 9.74321 5.42787L5.77256 1.7881L1.78033 5.78033Z"
                    fill="#000000"
                  ></path>
                </svg>
                <span>FAQs</span>
              </div>
              {panel === BundlePanels.faqs && (
                <div
                  className="bundle-panel-body"
                  dangerouslySetInnerHTML={{
                    __html: bundleOffer.faqs,
                  }}
                ></div>
              )}
            </div>
          )}

          {bundleOffer.terms && (
            <div className="bundle-panel">
              <div
                className="bundle-panel-header"
                onClick={() => setPanel(BundlePanels.terms)}
              >
                <svg
                  className={panel === BundlePanels.terms ? "rotate" : ""}
                  width="11"
                  height="6"
                  viewBox="0 0 11 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.78033 5.78033C1.48744 6.07323 1.01256 6.07323 0.71967 5.78033C0.426777 5.48744 0.426777 5.01256 0.71967 4.71967L5.21967 0.219671C5.5036 -0.0642633 5.96079 -0.0741975 6.25679 0.197135L10.7568 4.32214C11.0621 4.60203 11.0828 5.07646 10.8029 5.3818C10.523 5.68713 10.0485 5.70776 9.74321 5.42787L5.77256 1.7881L1.78033 5.78033Z"
                    fill="#000000"
                  ></path>
                </svg>
                <span>Terms</span>
              </div>
              {panel === BundlePanels.terms && (
                <div
                  className="bundle-panel-body"
                  dangerouslySetInnerHTML={{
                    __html: bundleOffer.terms,
                  }}
                ></div>
              )}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="bundle-description">
            {isLoading ? (
              <div className="icon-spin">
                <svg
                  className="spin"
                  viewBox="0 0 1024 1024"
                  focusable="false"
                  data-icon="loading"
                  width="1em"
                  height="1em"
                  fill="black"
                  aria-hidden="true"
                >
                  <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                </svg>
              </div>
            ) : (
              <h1>You have no access to this offer</h1>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default BundleLayout;
